import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "logo",
  "use": "logo-usage",
  "viewBox": "0 0 31 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 32\" id=\"logo\"><path fill-rule=\"evenodd\" stroke-width=\"0\" d=\"M30.999 0l-8.102 7.467L15.499.244 8.136 7.433 0 .025V32h30.999V0zM9.956 9.365l5.543-5.411 12.813 12.511V27.29L9.956 9.365zM2.686 16.7V6.056l1.241 1.132 22.725 22.189H15.668L2.686 16.699zm22.11-7.375l3.516-3.24v6.672l-3.515-3.432zM2.687 20.409l9.184 8.968H2.686v-8.968z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol